import React from 'react';

import { ReactComponent as GermanFlag } from '../../assets/323269-flags/svg/048-germany.svg';
import { ReactComponent as UKFlag } from '../../assets/323269-flags/svg/051-united-kingdom.svg';
import { ReactComponent as USFlag } from '../../assets/323269-flags/svg/070-united-states-of-america.svg';
import { SvgIcon } from '@material-ui/core';

export const GermanFlagIcon = props => {
  return (
    <SvgIcon {...props}>
      <GermanFlag />
    </SvgIcon>
  );
};

export const USFlagIcon = props => {
  return (
    <SvgIcon {...props}>
      <USFlag />
    </SvgIcon>
  );
};

export const UKFlagIcon = props => {
  return (
    <SvgIcon {...props}>
      <UKFlag />
    </SvgIcon>
  );
};
